export const DESCRIPTION_ROWS_COUNT = 10;

export const DESCRIPTION_MAX_LENGTH = 2000;
